<template>
  <div class="tools-container">
    <div
      v-if="!txtBook"
      class="item item-fit-w"
      v-tooltip="{
        content: this.$t('toolbox.fitHeight'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        :class="['font-icon-bar font-icon', { active: fit == 'height' }]"
        @click="fitToHeight"
      >
        d
      </div>
    </div>
    <div
      v-if="!txtBook"
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.fitWidth'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        :class="['font-icon-bar font-icon width', { active: fit == 'width' }]"
        @click="fitToWidth"
      >
        d
      </div>
    </div>
    <div
      class="item"
      v-if="!isWindow(tabId) && !this.$store.state.bookOnlyMode"
      v-tooltip="{
        content: this.$t('toolbox.fullScreen'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        :class="['font-icon-bar font-icon', { active: fullScreen }]"
        @click="setFullScreen"
      >
        {{ getFullScreenIcon }}
      </div>
    </div>

    <div tabindex="0" v-if="!txtBook" class="item" @keyup="doZoom">
      <baseDropDown
        :class="['left zoom', { active: zoomValue != 100 }]"
        :selfClose="false"
      >
        <template #button class="list-dropdown">
          <div
            class="font-icon-bar font-icon"
            v-tooltip="{
              content: $t('toolbox.zoom'),
              placement: 'right',
              classes: 'machon-tooltip',
            }"
          >
            f
          </div>
        </template>
        <template #list class="list-dropdown disable">
          <div class="flex flex-align-center flex-bet">
            <div
              class="present mrg-l-12 flex flex-align-center"
              style="line-height: 33px"
            >
              {{ zoomValue }}%
            </div>
            <div class="flex">
              <div
                class="zoom-act zoom-in icon-circle mrg-l-6"
                :class="{ disable: zoomValue >= maxZoom }"
                @click="zoomInOut(1)"
                @dblclick.stop
              >
                +
              </div>
              <div
                class="zoom-act zoom-out icon-circle mrg-l-6"
                :class="{ disable: zoomValue <= minZoom }"
                @click="zoomInOut(-1)"
                @dblclick.stop
              >
                -
              </div>
              <baseButton @dblclick.stop @click="initZoom">{{
                $t("toolbox.reset")
              }}</baseButton>
            </div>
          </div>
        </template>
      </baseDropDown>
    </div>
    <div tabindex="0" v-if="appMode.offline() && pdfBook" class="item">
      <baseDropDown
        v-if="appMode.offline()"
        :class="['left']"
        :selfClose="false"
      >
        <template #button class="list-dropdown">
          <div
            class="small-font flex flex-center flex-align-center font-w-normal"
            style="height: 25px; width: 25px"
          >
            <span
              v-tooltip="{
                content: $t('general.bookQuality'),
                placement: 'right',
                classes: 'machon-tooltip',
              }"
              class="pdf"
              ><img width="22px" height="22px" src="../../assets/pdf.png"
            /></span>
          </div>
        </template>
        <template #list>
          <div
            class="container lang-dir"
            style="height: 40px; padding: 5px; margin-bottom: 10px"
          >
            <p class="slider-title">{{ $t("general.bookQuality") }}</p>
            <PdfDpiSlider />
          </div>
        </template>
      </baseDropDown>
    </div>

    <!--     <div tabindex="0" v-if="!txtBook" class="item">
      <div
        @click="photoEditShow = !photoEditShow"
        class="font-icon-bar font-icon"
        v-tooltip="{
          content: $t('toolbox.zoom'),
          placement: 'right',
          classes: 'machon-tooltip',
        }"
      >
        f
      </div>

      <div class="lst-photo-edit" v-if="photoEditShow">
        <div class="lst-photo-line">
          <span>בהירות</span>
          <div>
            <VueSlider
              v-model="$store.state.tabs[tabId].imageEdit.brightness"
              @change="enableImageEdit"
              :lazy="true"
              v-bind="brightnessSliderOptions"
            />
          </div>
        </div>
        <div class="lst-photo-line">
          <span>ניגודיות</span>
          <VueSlider
            v-model="$store.state.tabs[tabId].imageEdit.contrast"
            @change="enableImageEdit"
            :lazy="true"
            v-bind="brightnessSliderOptions"
          />
        </div>
        <div class="lst-photo-line">
          <span>invert</span>
          <VueSlider
            v-model="$store.state.tabs[tabId].imageEdit.invert"
            @change="enableImageEdit"
            :lazy="true"
            v-bind="brightnessSliderOptions"
          />
        </div>
        <div class="lst-photo-line">
          <span>saturate</span>
          <VueSlider
            v-model="$store.state.tabs[tabId].imageEdit.saturate"
            @change="enableImageEdit"
            :lazy="true"
            v-bind="brightnessSliderOptions"
          />
        </div>
        <div class="lst-photo-line">
          <span>sepia</span>
          <VueSlider
            v-model="$store.state.tabs[tabId].imageEdit.sepia"
            @change="enableImageEdit"
            :lazy="true"
            v-bind="brightnessSliderOptions"
          />
        </div>
        <div class="lst-photo-line">
          <span>grayscale</span>
          <VueSlider
            v-model="$store.state.tabs[tabId].imageEdit.grayscale"
            @change="enableImageEdit"
            :lazy="true"
            v-bind="brightnessSliderOptions"
          />
        </div>
      </div>

    </div> -->
    <div class="seperator"></div>
    <!-- *****2***** -->
    <div
      v-if="1 == 2"
      class="item mm-icon"
      @click="setFindMmWin(!showFindMmWin)"
    >
      <div
        class="font-icon-bar font-icon"
        v-tooltip="{
          content: $t('mmSearch.searchMM'),
          placement: 'right',
          classes: 'machon-tooltip',
        }"
      >
        m
      </div>
    </div>
    <div
      v-if="!txtBook && !customBook"
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.ocr'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        v-kiosk
        :class="['font-icon-bar font-icon', { active: OCREnabled }]"
        @click="toggleOcr"
      >
        b
      </div>
    </div>
    <div
      class="item"
      v-tooltip="{
        content: printToolTip,
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        v-disable
        :class="[
          'font-icon-bar font-icon',
          { active: printBookVisibility },
          { disable: !bookAllowed },
        ]"
        @click="print"
      >
        h
      </div>
    </div>
    <div class="seperator"></div>
    <!-- ***3*** -->
    <div
      v-if="!txtBook"
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.userExtens'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        v-kiosk
        :class="['font-icon-bar font-icon', { active: showAdds }]"
        @click="showUserAdditions"
      >
        c
      </div>
    </div>
    <div
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.link'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div class="font-icon-bar font-icon" @click="link">i</div>
    </div>
    <div class="seperator"></div>
    <div
      v-if="!$store.state.bookOnlyMode"
      class="item fav"
      :class="{ active: getFavActive }"
      v-tooltip="{
        content: this.getFavoritesTooltip,
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div class="font-icon-bar font-icon" v-kiosk @click="addToFavorites">
        {{ getFavoritesIcon }}
      </div>
    </div>
    <!-- <div class="item">
      <div class="font-icon-bar font-icon" @click="search">m</div>
    </div> -->

    <!-- <div class="item">
      <div class="font-icon-bar font-icon" @click="search">m</div>
    </div> -->

    <!-- <div class="item">
      <div class="font-icon-bar font-icon" @click="search">m</div>
    </div> -->

    <!-- <div class="item">
      <div class="font-icon-bar font-icon" @click="search">m</div>
    </div> -->
    <div
      v-if="!txtBook && !customPDFBook && !customBook"
      class="item mm-icon"
      @click="toggleMM"
      v-tooltip="{
        content: mmToolTip,
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div class="font-icon-bar font-icon" :class="{ active: showMm }" v-kiosk>
        {{ getIconMM }}
      </div>
    </div>
    <!-- <div class="item">
      <div class="font-icon-bar font-icon" @click="search">m</div>
    </div> -->

    <div
      v-if="hasFsResults"
      class="item"
      @click="removeFsMarks()"
      v-tooltip="{
        content: showHideFs,
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        :class="['font-icon-bar font-icon hide-results', { active: !drawFs }]"
      >
        <div v-if="!drawFs">
          <div class="mef-icon">l</div>
        </div>
        <div v-if="drawFs">
          <div class="mef-icon">l</div>
        </div>
      </div>
    </div>

    <div class="seperator" v-if="!$store.state.bookOnlyMode"></div>

    <div
      v-if="!$store.state.bookOnlyMode"
      class="item"
      @click="addBook()"
      v-tooltip="{
        content: this.$t('toolbox.openBook'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div class="font-icon-bar font-icon">j</div>
    </div>
    <!-- <div
      v-if="txtBook"
      class="item"
      @click="removeFsMarks()"
      v-tooltip="{
        content: this.$t('toolbox.removeFs'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <baseDropDown :class="['search']" :selfClose="false">
        <template #button class="list-dropdown">
          <div class="font-icon-bar font-icon">m</div>
        </template>
        <template #list class="list-dropdown disable">
          <div class="w-100">
            <ComboboxInput
              class="fit-height "
              :items="listFonts"
              @input="chooseFonts($event)"
              :labelStart="1"
              :labal="listFonts[0]"
              :labelKey="1"
            />


          </div>
        </template>
      </baseDropDown>
    </div> -->
    <div
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.detailesBook'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        :class="['font-icon-bar font-icon', { active: bookDetailsVisibility }]"
        @click.stop="bookDetails"
      >
        a
      </div>
    </div>

    <div class="seperator" v-if="!$store.state.bookOnlyMode"></div>

    <div v-if="!$store.state.bookOnlyMode && isMefoMask" class="item">
      <div
        :class="[
          'font-icon-bar font-icon center-it',
          { active: $store.state.tabs[this.tabId].showMask },
        ]"
        class="hide-results"
        @click.stop="toggleMask"
      >
        <div
          v-if="$store.state.tabs[this.tabId].showMask"
          v-tooltip="{
            content: this.$t('toolbox.maskOff'),
            placement: 'right',
            classes: 'machon-tooltip',
          }"
        >
          <div class="mef-icon">l</div>
        </div>
        <div
          v-if="!$store.state.tabs[this.tabId].showMask"
          v-tooltip="{
            content: this.$t('toolbox.maskOn'),
            placement: 'right',
            classes: 'machon-tooltip',
          }"
          :class="[
            'font-icon-bar font-icon center-it',
            { active: $store.state.tabs[this.tabId].showMask },
          ]"
          @click.stop="toggleMask"
        >
          <div class="mef-icon">x</div>
        </div>
      </div>
    </div>

    <div
      v-if="
        showMefFeuthures &&
        !$store.state.bookOnlyMode &&
        !tabId.startsWith('win') &&
        isMefo
      "
      class="item"
      v-tooltip="{
        content: isMefoOn
          ? this.$t('toolbox.mefOff')
          : this.$t('toolbox.mefOn'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
      :class="{ active: isMefoOn }"
    >
      <div
        :class="['font-icon-bar font-icon center-it']"
        @click.stop="toggleMefo"
      >
        <Icons icon="power" height="22px" width="22px" />
      </div>
    </div>

    <div
      v-if="
        false &&
        !$store.state.bookOnlyMode &&
        !tabId.startsWith('win') &&
        isMefo
      "
      class="item"
      v-tooltip="{
        content: $store.state.mefo.showMefoArea
          ? this.$t('toolbox.mefAreaOff')
          : this.$t('toolbox.mefAreaOn'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div
        :class="[
          'font-icon-bar font-icon center-it',
          { active: $store.state.mefo.showMefoArea },
        ]"
        @click.stop="toggleMefoArea"
      >
        <Icons
          icon="open-section"
          height="18px"
          width="18px"
          stroke="#626262"
        />
      </div>
    </div>
    <!--  <div
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.rotateImage'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div :class="['font-icon-bar font-icon']" @click.stop="rotatePage">
        a
      </div>
    </div> -->
    <div
      v-if="false && !txtBook"
      class="h-100 flex align-item-center"
      @click.stop="rotatePage"
    >
      <iconCircle
        class="h-100 flex align-item-center icon-refresh"
        nameIcon="icon-refresh"
        v-tooltip="{
          content: this.$t('toolbox.rotateImage'),
          placement: 'right',
          classes: 'machon-tooltip',
        }"
      />
    </div>
    <div
      v-if="isShasYesod && !tabId.startsWith('win')"
      class="item"
      v-tooltip="{
        content: this.$t('toolbox.startMefo'),
        placement: 'right',
        classes: 'machon-tooltip',
      }"
    >
      <div :class="['font-icon-bar font-icon center-it']" @click="goToMefo">
        <Icons icon="section" height="18px" width="18px" stroke="#626262" />
      </div>
    </div>

    <div
      v-if="!$_mobile"
      class="item h-100 flex align-item-center"
      @click.stop="showHeaders"
      v-tooltip="{ content: this.$t('book.showBookHeaders') }"
    >
      <div :class="['font-icon-bar font-icon center-it']">
        <Icons icon="rows" height="22px" width="22px" />
      </div>
    </div>
    <div
      v-version.up="23"
      class="item h-100 flex align-item-center"
      @click.stop="toggleBookMark"
      v-tooltip="{ content: this.$t('general.setBookmarkPosition') }"
    >
      <div
        :class="[
          'font-icon-bar font-icon center-it bookmark ',
          { active: showBookMark },
        ]"
      >
        <Icons icon="bookmark" height="22px" width="22px" />
      </div>
    </div>
    <!--   <div
      class="item h-100 flex align-item-center"
      @click.stop="toggleZoomMode"
      v-tooltip="{ content: this.$t('book.showBookMark') }"
    >
      <div :class="['font-icon-bar font-icon center-it']">
        <Icons
          icon="magnifier"
          height="22px"
          width="22px"
          :stroke="zoomMode ? 'red' : 'black'"
        />
      </div>
    </div> -->
    <!--   <div
      class="item h-100 flex align-item-center"
      @click.stop="toggleBookMark"
      v-tooltip="{ content: this.$t('book.showBookMark') }"
    >
      <div :class="['font-icon-bar font-icon center-it']">
        <Icons
          icon="rows"
          height="22px"
          width="22px"
          :fill="showBookMark ? 'blue' : 'white'"
        />
      </div>
    </div>
    <div
      class="item h-100 flex align-item-center"
      @click.stop="toggleZoomMode"
      v-tooltip="{ content: this.$t('book.showBookMark') }"
    >
      <div :class="['font-icon-bar font-icon center-it']">
        <Icons
          icon="magnifier"
          height="22px"
          width="22px"
          :stroke="zoomMode ? 'red' : 'black'"
        />
      </div>
    </div> -->
  </div>
</template>
<script>
import { doFreeSearch, setSearchType } from "@/services/freeSearch.js";
import { allowedToPrint, startPrint } from "@/services/print.js";
import { mapActions, mapGetters, mapState } from "vuex";
// import VueSlider from "vue-slider-component/dist-css/vue-slider-component.umd.min.js";
// import VueSlider from "vue-slider-component";
// import "vue-slider-component/dist-css/vue-slider-component.css";
// import "vue-slider-component/theme/antd.css";
import Icons from "@/components/Icons/Icons.vue";
// import init from "@/config/init.js";
import { IPUserNoPersDataMsg } from "@/services/userBooksData.js";
// import theme
import "vue-slider-component/theme/default.css";
import * as tabModule from "@/store/modules/_tab.js";
import { openBook, getMefoBookByDaf } from "@/services/bookData.js";
import winBooksMgr from "@/services/book_win.js";
import mixMefo from "@/mixing/mixIsMefo";
import PdfDpiSlider from "@/components/book/PdfDpiSlider";

export default {
  components: {
    // VueSlider,
    Icons,
    PdfDpiSlider,
  },
  mixins: [mixMefo],
  data() {
    return {
      zoomMode: false,
      photoEditShow: false,
      showPrintBox: false,
      zoomValue: 100,
      brightnessVal: 0,
      brightnessSliderOptions: {
        min: 0,
        max: 100,
        processStyle: { top: "0px" },
      },
      searchTxt: "",
      closeFS: true,
      showMM: false,
      maxZoom: 250,
      minZoom: 40,
      zoomKey: "",
      lastZoomKey: "",
      searchTimer: null,
    };
  },
  props: [
    "book",
    "page",
    "showDetails",
    "showPrint",
    "tabId",
    "showAdds",
    "drawFs",
    "showMefFeuthures",
  ],
  watch: {
    /** @todo mistake: params order */
    zoomValue: function (val, oval) {
      this.zoom(val);
    },
    tabZoom: function (newV, oldV) {
      this.zoomValue = newV;
    },
  },

  computed: {
    ...mapGetters("books", ["getBookbyId"]),
    ...mapGetters("user", ["isIPLimited"]),
    ...mapState("bookPopups", [
      "printBookVisibility",
      "bookDetailsVisibility",
      "OCREnabled",
      "personalExtVisibility",
    ]),
    ...mapGetters("userSetting", ["showMm"]),
    // ...mapState("userSetting", ["viewPlacesRegularly"]),
    ...mapGetters("tabsManager", [
      "fullScreen",
      "isWindow",
      "tabsOverflow",
      "winBooksOverflow",
    ]),
    ...mapGetters("findMm", ["showFindMmWin"]),
    ...mapGetters("user", ["isUserGuest"]),
    isMefoOn() {
      return this.$store.getters[`tabs/${this.tabId}/isMefoOn`];
    },
    showBookMark() {
      return (
        this.$store.getters[`tabs/${this.tabId}/getBookmarkStatus`] != "off"
      );
    },
    bookVolume() {
      return this.getBookbyId(this.book)?.volume || "";
    },
    isShasYesod() {
      return shasOz.includes(this.book);
    },
    printToolTip() {
      return this.bookAllowed
        ? this.$t("toolbox.print")
        : this.isUserGuest
        ? this.$t("toolbox.guestNoPrint")
        : this.$t("toolbox.bookNoPrint");
    },
    tabZoom() {
      return this.$store.state.tabs[this.tabId].zoom;
    },

    isMefoMask() {
      //if (!masks) return 0;
      let masks = this.$store.state.tabs[this.tabId].masks;
      if (!masks) return 0;
      return Object.keys(masks).length;
    },
    openFs() {
      return this.$store.state.tabs[this.tabId].openFs;
    },

    toggleMmStyle() {
      if (this.showMM) return this.$t("toolbox.hideMM");
      return this.$t("toolbox.showMM");
    },

    txtBook() {
      return this.$store.state.tabs[this.tabId].txtBook;
    },
    pdfBook() {
      return this.$store.state.tabs[this.tabId].pdfBook;
    },
    hasFsResults() {
      return this.$store.getters[`tabs/${this.tabId}/hasFsResults`];
    },
    customBook() {
      return this.otzarBook.type(this.book) == "custom";
    },
    customPDFBook() {
      return this.otzarBook.type(this.book) == "customPDF";
    },

    bookInFavorites() {
      let x = this.$store.state.userFavoriteBooks.favoriteChange;
      return this.$store.getters[`tabs/${this.tabId}/bookInFavorites`];
    },
    getFavoritesIcon() {
      let x = this.$store.state.userFavoriteBooks.favoriteChange;
      return !this.bookInFavorites ? "g" : "O";
    },
    getFavoritesTooltip() {
      let x = this.$store.state.userFavoriteBooks.favoriteChange;
      let tooltip;
      if (this.bookInFavorites) tooltip = this.$t("toolbox.removefavorites");
      else tooltip = this.$t("toolbox.favorites");
      return tooltip;
    },
    getFavActive() {
      if (this.$store.state.userFavoriteBooks.favoriteChange) {
        return true;
      }
      return false;
    },
    mmToolTip() {
      return this.showMm ? this.$t("toolbox.hideMM") : this.$t("toolbox.mm");
    },
    getFullScreenIcon() {
      return this.fullScreen ? "e" : "e";
    },
    fit() {
      return this.$store.state.tabs[this.tabId].bookFit;
    },
    bookAllowed() {
      return (
        (!this.isUserGuest || globalThis.DEV_CONNECT_USER_TO_FREE_AUTO) &&
        allowedToPrint(this.book.toString()) &&
        this.$store.getters[`tabs/${this.tabId}/isBookAllowedToUser`]
      );
    },
    // listFonts() {
    //   let fonts = systemFonts().data;
    //   fonts.forEach((font, i) => {
    //     let a = font;
    //     if (a) {
    //       a = a.split("\\");
    //       a = a[a.length - 1].split(".");
    //       let b = {};
    //       b.label = a[0];
    //       b.name = a[0];
    //       b.key = 0;
    //       fonts[i] = b;
    //     }
    //   });

    //   return fonts;
    // },
    showHideFs() {
      if (this.drawFs) return this.$t("toolbox.removeFs");
      return this.$t("toolbox.showFs");
    },
    getIconMM() {
      if (!this.showMm) return "k";
      return "z";
    },
  },
  methods: {
    ...mapActions("createBook", ["setAction"]),
    ...mapActions("tabsManager", ["toggleFullScreen"]),
    ...mapActions("userSetting", ["setMm"]),
    ...mapActions("findMm", ["setFindMmWin"]),
    ...mapActions("userFavoriteBooks", [
      "addFavoriteBook",
      "removeFavoriteBook",
    ]),
    ...mapActions("bookPopups", [
      "togglePrintBookVisible",
      "toggleBookDetailsVisible",
      "setOCREnable",
      "togglePersonalExtVisible",
    ]),
    toggleZoomMode() {
      this.zoomMode = !this.zoomMode;
      this.$store.state.tabs[this.tabId].zoomMode = this.zoomMode;
    },
    toggleBookMark() {
      if (
        this.$store.getters[`tabs/${this.tabId}/getBookmarkStatus`] != "off"
      ) {
        this.$store.dispatch(`tabs/${this.tabId}/setBookmarkStatus`, "off");
        this.removeBookmarkFromSettings();
      } else
        this.$store.dispatch(`tabs/${this.tabId}/setBookmarkStatus`, "init");
    },
    removeBookmarkFromSettings() {
      let currentSetting = this.userSettings.settings.bookmarks;
      if (!currentSetting) return;
      currentSetting = JSON.parse(currentSetting);
      delete currentSetting[this.book.toString()];

      this.userSettings.setSettings(
        "bookmarks",
        JSON.stringify(currentSetting)
      );
    },
    showHeaders() {
      this.$store.state.tabsManager.showHeadersTabId = this.tabId;
    },
    goToMefo() {
      let masechet = this.bookVolume.split("-");
      if (masechet[1]) {
        masechet = masechet[1]
          .trim()
          .substr(masechet[1].trim().indexOf(" ") + 1)
          .trim();

        let currentPage =
          this.$store.state.tabs[this.tabId].pages[this.page - 1];
        if (currentPage) {
          currentPage = currentPage.pagedata[0]?.letter;
          if (currentPage) {
            currentPage = currentPage.split(" ");
            let daf = "ב";
            let amud = "א";
            if (currentPage.length == 2) {
              daf = currentPage[0];
              amud = currentPage[1];
            }
            let mefBook = getMefoBookByDaf(masechet, daf, amud);
            if (mefBook) openBook(mefBook.bookId, mefBook.page);
          }
        }
      }
    },
    enableImageEdit() {
      if (this.$store.state.tabs[this.tabId].imageEdit.changed > 1000)
        this.$store.state.tabs[this.tabId].imageEdit.changed = 0;
      this.$store.state.tabs[this.tabId].imageEdit.changed++;
      this.$store.state.tabs[this.tabId].imageEdit.enable = true;
    },
    rotatePage() {
      this.$emit("rotateImage");
    },
    toggleMefo() {
      this.$store.dispatch(`tabs/${this.tabId}/toggleMefoOn`, null, {
        root: true,
      });
    },
    toggleMask(e) {
      let val = this.$store.state.tabs[this.tabId].showMask;
      this.$store.state.tabs[this.tabId].showMask = !val;
    },
    toggleMefoArea() {
      this.$store.dispatch(
        "mefo/setShowMefoArea",
        !this.$store.state.mefo.showMefoArea
      );
    },
    doZoom(event) {
      this.lastZoomKey = new Date().getTime();
      this.zoomKey += event.key;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.doZoomPage, 500);
    },
    doZoomPage() {
      try {
        let found;
        let searchtxt = this.zoomKey;
        //check if it a valid  number
        if (
          !isNaN(searchtxt) &
          (parseInt(searchtxt) <= 250) &
          (parseInt(searchtxt) >= 40)
        ) {
          let zoom = parseInt(searchtxt);
          if (zoom > this.maxZoom) zoom = this.maxZoom;
          else if (zoom < this.minZoom) zoom = this.minZoom;
          this.zoomValue = zoom;
        }

        this.searchTimer = setTimeout(this.resetPageSearch, 1000);
      } catch (ex) {
        //console.error(ex);
      }
    },
    resetPageSearch() {
      if (new Date().getTime() - this.lastZoomKey > 1000) this.zoomKey = "";
    },
    removeFsMarks() {
      this.$emit("drawFs", !this.drawFs);
    },
    toggleMM() {
      this.setMm({ key: "show", value: !this.showMm });
    },
    async addBook() {
      let currentTab = this.$store.state.tabs[this.tabId];

      currentTab = JSON.parse(JSON.stringify(currentTab));
      let tab = currentTab;
      tab.id = "win_" + new Date().getTime();
      tab.winWidth = document.body.clientWidth * 0.9;
      tab.winHeight = document.body.clientHeight * 0.9;
      tab.minimize = false;

      const overflow = tab.id.startsWith("win_")
        ? this.winBooksOverflow
        : this.tabsOverflow;
      if (overflow) {
        if (!(await winBooksMgr.tabsOverflowWarning(tab.id.startsWith("win_"))))
          return;
      }

      let newTab = Object.assign({}, tabModule);
      newTab.state = function () {
        return tab;
      };

      this.$store.registerModule(["tabs", tab.id], newTab);
      this.$store.state.tabs[tab.id].SHAS_SECTION_LIST_ID = null;
      this.$store.state.tabsManager.tabs.push(tab.id);
      //close details window
      this.$store.dispatch("bookPopups/closeBookDetails");
      // this.openbooks.push(this.currentTabId);
    },
    setFullScreen() {
      this.toggleFullScreen();
      // }
    },
    setSearchTxt(e) {
      this.searchTxt = e.target.value;
    },
    initZoom() {
      this.zoomValue = 100;
    },
    openFullscreen() {
      const elem = document.body;

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },
    zoomInOut(dir) {
      let zoom = this.zoomValue + 10 * dir;
      if (zoom > this.maxZoom) zoom = this.maxZoom;
      else if (zoom < this.minZoom) zoom = this.minZoom;
      this.zoomValue = zoom;
    },
    bookDetails() {
      this.$emit("book-details", !this.showDetails);
      // this.toggleBookDetailsVisible();
    },
    triggerResize() {
      this.$store.dispatch(`tabs/${this.tabId}/triggerResize`, null, {
        root: true,
      });
    },
    fitToHeight() {
      this.zoomValue = 100;

      this.$store
        .dispatch(
          `tabs/${this.tabId}/setZoom`,
          { zoom: this.zoomValue },
          {
            root: true,
          }
        )
        .then(() => {
          this.$store
            .dispatch(`tabs/${this.tabId}/setBookFit`, "height", {
              root: true,
            })
            .then(() => {
              this.triggerResize();
            });
        });
    },
    fitToWidth() {
      this.$store.dispatch(`tabs/${this.tabId}/setBookFit`, "width", {
        root: true,
      });
      this.triggerResize();
    },
    zoom() {
      this.$store
        .dispatch(`tabs/${this.tabId}/setBookFit`, "width", {
          root: true,
        })
        .then(() => {
          this.$store.dispatch(
            `tabs/${this.tabId}/setZoom`,
            { zoom: this.zoomValue },
            {
              root: true,
            }
          );
          setTimeout(this.triggerResize(), 0);
        });
    },
    showUserAdditions() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.$emit("show-add-win");
    },
    addToFavorites() {
      let books = [this.book];

      if (this.bookInFavorites) this.removeFavoriteBook({ books });
      else this.addFavoriteBook({ books });
    },
    print() {
      if (!this.bookAllowed) return;
      if (this.showPrint) this.$emit("print", { show: !this.showPrint });
      else if (startPrint(this.tabId) === true)
        this.$emit("print", { show: !this.showPrint });

      return;
    },
    search() {
      this.closeFS = true;
      this.$store.state.freeSearch.inBook = true;
      if (this.searchTxt != "") {
        this.$emit("search", {
          show: true,
          txt: this.searchTxt.trim(),
        });
        setSearchType("classic");
        doFreeSearch(
          this.searchTxt.trim().replace(/[\u0591-\u05C7]/g, ""), //remove niqud,
          [this.book],
          0,
          true,
          this.tabId
        ).then(() => {
          this.$emit("search", {
            show: false,
            txt: this.searchTxt.trim(),
          });
        });
        this.searchTxt = "";
      }
    },
    link() {
      let link;
      let fsData = this.$store.state.tabs[this.tabId].drawData?.fs;
      if (!fsData) fsData = { fs: 0, start: 0, end: 0 };
      link = `${location.protocol}//${window.location.host}/#/book/${
        this.book
      }/p/${this.page}/t/${this.tabId.slice(4)}1234/fs/${fsData.fs}/start/${
        fsData.start
      }/end/${fsData.end}/c`;
      link = link.replace("file:///#/", "OtzarBook://");

      navigator.clipboard.writeText(link).then(() => {
        const notification = {
          type: "success",
          message: this.$t("link.message"),
          timeout: 7000,
          setting: {
            grid: "icon",
            nameIcon: "copy",
            position: "center",
          },
        };
        this.$notify(notification);
      });
    },
    toggleOcr() {
      this.setOCREnable(!this.OCREnabled);
    },
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  mounted() {
    this.zoomValue = this.$store.state.tabs[this.tabId]?.zoom || 100;

    // this.$emit("drawMM", this.showMm);
  },
};

const shasOz = [
  "142552",
  "142553",
  "142554",
  "142555",
  "142556",
  "142557",
  "142558",
  "142559",
  "142560",
  "142561",
  "142562",
  "142563",
  "142564",
  "142565",
  "142566",
  "142567",
  "142568",
  "142569",
  "142570",
  "142571",
  "142572",
  "142573",
  "142574",
  "142575",
  "142576",
  "142577",
  "142578",
  "142579",
  "142580",
  "142581",
  "142582",
  "142583",
  "142584",
  "142585",
  "142586",
  "142587",
  "142588",
  "142589",
  "142590",
  "142591",
  "142592",
];
</script>
<style lang="scss">
.tv-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 24px;
  height: 24px;
  margin: 9px;
  cursor: pointer;
}
.vue-slider {
  top: 17px;
}
.vue-slider-dot-handle,
.vue-slider-process {
  background-color: var(--custom-color1);
}
.vue-slider-dot-tooltip {
  visibility: visible;
  top: 5px;
}
.vue-slider-dot-tooltip-inner-top::after {
  content: "%";
  top: 0;
  transform: translate(0);
  border: 0;
  font-size: 12px;
  height: 100%;
  width: 10px;
  line-height: 26px;
  right: -5px;
}
.vue-slider-dot-tooltip-inner {
  background-color: transparent;
  color: #000;
  font-size: 12px;
  font-weight: 600;
}

.zoom-act {
  font-size: 22px;
  text-align: center;
  line-height: 21px;
}
.item-fit-w {
  margin-top: -2px;
  margin-bottom: -2px;
}
.toolbox-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom-border {
  border-bottom: #e5e5e5 1px solid;
}
.lst-photo-line {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.lst-photo-edit {
  position: absolute;
  left: 40px;
  padding: 10px;
  z-index: 10;
  top: -30px;
  width: 200px;
  height: 400px;
  background-color: #f7f7f7;
  border: solid;
  border-width: 1px;
  border-color: #909090;
  border-left-width: 0px;
}
.tools-container .item {
  height: 36px;
  width: 38px;
  line-height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tools-container .font-icon-bar {
  border-radius: 3px;
  font-size: 35px;
  text-align: center;
  height: 33px;
  width: 33px;
  line-height: 33px;
  color: #626262;
  &:hover:not(.active),
  &:not(.disable):hover {
    color: #000;
  }
  &.active {
    background-color: #0000001f;
    //  border: 1px solid 0000001f;
  }
  &.width {
    transform: rotate(90deg);
    // height: 29px;
    // width: 33px;
  }
}
.font-icon-bar:hover {
  // color: darkgray;
  background-color: #00000014;
  cursor: pointer;
}
.fav.active .font-icon-bar {
  color: var(--custom-color1);
}
.item {
  position: relative;

  .zoom {
    .list-dropdown {
      left: 100% !important;
      top: 0;
      height: 100%;
      width: 200px;
      box-shadow: 0 2px 3px 1px #0000005c;
      background-color: #f7f7f7;
      padding: 10px 10px 10px 5px;
      height: 33px;
      padding: 0px 10px;
      .flex-align-center {
        height: 100%;
      }
    }
  }
}
.item:active {
  top: 1px;
}
.search {
  .list-dropdown {
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    width: 300px;
    left: 100%;
  }
}
.disable {
  opacity: 0.3;
  cursor: default;
}
.icon-hide-results {
  position: absolute;
  top: 17px;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.hide-results {
  .mef-icon {
    font-size: 61px;
  }
}
.mm-icon .font-icon-bar.active {
  color: var(--custom-color1) !important;
}
.seperator {
  border-bottom: 1px solid #e5e5e5 !important;
  height: 1px !important;
  background-color: transparent !important;
  width: 100%;
}
.center-it {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pdf {
  padding-top: 12px;
}
.slider-title {
  text-align: center;
  font-size: 12px;
  line-height: 13px;
  margin: 0;
  margin-top: 2px;
}
.item {
  &.active {
    svg {
      fill: var(--custom-color1);
    }
  }
}
.bookmark.active {
  background: #fff;
  svg {
    fill: var(--custom-color1) !important;
  }
}
</style>
